import { useHead } from '#imports'
import { usePageStore } from '~/store/page'

export const loadScripts = () => {
  console.log('Loading scripts...')
  const preloadScripts = {
    script: [] as any[]
  }

  const pageStore = usePageStore()
  const { $preview } = useNuxtApp()

  if (!process.dev && !$preview) {
    preloadScripts.script.push(
      {
        async: false,
        defer: true,
        src: '/js/cookie-banner.js',
        onload: () => {
          pageStore.setCookieBannerLoaded(true)
          console.log('✔ Cookie banner loaded!')
        },
        onerror: () => {
          throw new Error('Cookie banner failed to load')
        }
      }
    )

    preloadScripts.script.push(
      {
        async: false,
        defer: true,
        src: 'https://npotag.npo-data.nl/prod/npo-tag.js',
        onload: () => {
          pageStore.setNpoTagLoaded(true)
          console.log('✔ Npo tag loaded!')
        },
        onerror: () => {
          throw new Error('Npo tag failed to load')
        }
      }
    )
  }

  return useHead(preloadScripts)
}
